export default __webpack_public_path__ + "static/media/footer-top.e7fb55e5.png";